"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _AnimateTransition = _interopRequireDefault(require("../../components/transition/AnimateTransition"));

var SLIDER_ANIMATIONS = {
  closed: {
    keyframes: [{
      transform: 'translateX(-100%)',
      opacity: 0,
      pointerEvents: 'none'
    }]
  },
  open: {
    keyframes: [{
      transform: 'translateX(-100%)',
      opacity: 0,
      pointerEvents: 'none'
    }, {
      transform: 'translateX(0%)',
      opacity: 1,
      pointerEvents: 'auto'
    }],
    duration: 150,
    easing: 'ease-in'
  }
};

var Slider = function Slider(_ref) {
  var open = _ref.open,
      onToggle = _ref.onToggle,
      trigger = _ref.trigger,
      title = _ref.title,
      children = _ref.children;
  return (0, _preact.h)("div", {
    className: "slider-menu"
  }, (0, _preact.h)("span", {
    className: "slider-trigger",
    onClick: function onClick() {
      return onToggle(true);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && onToggle(true);
    },
    role: "button",
    tabIndex: 0
  }, trigger), (0, _preact.h)(_AnimateTransition.default, {
    enter: "open",
    exit: "closed",
    states: SLIDER_ANIMATIONS
  }, open && (0, _preact.h)("div", {
    className: "slider-content"
  }, (0, _preact.h)("div", {
    className: "slider-header"
  }, (0, _preact.h)(_Close.default, {
    width: 21,
    height: 21,
    onClick: function onClick() {
      return onToggle(false);
    },
    role: "button",
    tabIndex: 0,
    "aria-label": "Close slider",
    style: {
      cursor: 'pointer'
    }
  }), (0, _preact.h)("div", {
    className: "slider-title text-center"
  }, title)), children)));
};

var _default = Slider;
exports.default = _default;